import { actionTypesReports as actionTypes } from "./../constants/actionTypesReports";
import {
  stockModel,
  reserveStockModel,
  productModel,
  customerStatusModel,
  customerOrderModel,
  pmxOverviewModel,
  pmxDetailModel,
  productionStockModel,
  rawMaterialStockOverviewModel,
  rawMaterialStockModel,
  deliveryModel,
  usageL36M2Model,
  usageL36M2V2Model,
  valueL36MModel,
  invoiceDNDetailModel,
} from "../../models/reportsModel";

const setStockReportList = (data: Array<stockModel>) => {
  return {
    type: actionTypes.ListOfStockReport,
    payload: data,
  };
};

const setReserveStockReportList = (data: Array<reserveStockModel>) => {
  return {
    type: actionTypes.ListOfReserveStockReport,
    payload: data,
  };
};

const setLastRefreshStockReport = (data: string) => {
  return {
    type: actionTypes.LastRefreshStockReport,
    payload: data,
  };
};

const setCustomerStatusReportList = (data: Array<customerStatusModel>) => {
  return {
    type: actionTypes.ListOfCustomerStatus,
    payload: data,
  };
};

const setCustomerOrderReportList = (data: Array<customerOrderModel>) => {
  return {
    type: actionTypes.ListOfCustomerOrder,
    payload: data,
  };
};

const setPmxInventoryReportList = (data: Array<pmxOverviewModel>) => {
  return {
    type: actionTypes.ListOfPmxInventory,
    payload: data,
  };
};

const setPmxInventoryDetailReportList = (data: Array<pmxDetailModel>) => {
  return {
    type: actionTypes.ListOfPmxInventoryDetail,
    payload: data,
  };
};

const setDeliveryReportList = (data: Array<deliveryModel>) => {
  return {
    type: actionTypes.ListOfDelivery,
    payload: data,
  };
};

const setProductReportList = (data: Array<productModel>) => {
  return {
    type: actionTypes.ListOfProductReport,
    payload: data,
  };
};

const setLastRefreshProductReport = (data: string) => {
  return {
    type: actionTypes.LastRefreshProductReport,
    payload: data,
  };
};

const setProductionStockReportList = (data: Array<productionStockModel>) => {
  return {
    type: actionTypes.ListOfProductionStockReport,
    payload: data,
  };
};

const setRawMaterialOverviewStockReportList = (
  data: Array<rawMaterialStockOverviewModel>
) => {
  return {
    type: actionTypes.ListOfRawMaterialOverviewStockReport,
    payload: data,
  };
};

const setRawMaterialStockReportList = (data: Array<rawMaterialStockModel>) => {
  return {
    type: actionTypes.ListOfRawMaterialStockReport,
    payload: data,
  };
};

const setUsageL36M2ReportList = (data: Array<usageL36M2Model>) => {
  return {
    type: actionTypes.ListOfUsageL36M2,
    payload: data,
  };
};

const setUsageL36M2V2ReportList = (data: Array<usageL36M2V2Model>) => {
  return {
    type: actionTypes.ListOfUsageL36M2V2,
    payload: data,
  };
};

const setValueL36MReportList = (data: Array<valueL36MModel>) => {
  return {
    type: actionTypes.ListOfValueL36M,
    payload: data,
  };
};

const setInvoiceDNDetailReportList = (data: Array<invoiceDNDetailModel>) => {
  return {
    type: actionTypes.ListOfInvoiceDNDetail,
    payload: data,
  };
};

const setUsageL36M2V2HiddenColumns = (columns: Array<string>) => {
  return {
    type: actionTypes.SetUsageL36M2V2HiddenColumns,
    payload: columns,
  };
};

const setValueL36MHiddenColumns = (columns: Array<string>) => {
  return {
    type: actionTypes.SetValueL36MHiddenColumns,
    payload: columns,
  };
};

const setInvoiceDNDetailHiddenColumns = (columns: Array<string>) => {
  return {
    type: actionTypes.SetInvoiceDNDetailHiddenColumns,
    payload: columns,
  };
};

const setUsageL36M2V2ColumnOrder = (order: Array<string>) => {
  return {
    type: actionTypes.SetUsageL36M2V2ColumnOrder,
    payload: order,
  };
};

const setValueL36MColumnOrder = (order: Array<string>) => {
  return {
    type: actionTypes.SetValueL36MColumnOrder,
    payload: order,
  };
};

const setInvoiceDNDetailColumnOrder = (order: Array<string>) => {
  return {
    type: actionTypes.SetInvoiceDNDetailColumnOrder,
    payload: order,
  };
};

export default {
  setStockReportList,
  setReserveStockReportList,
  setLastRefreshStockReport,
  setCustomerStatusReportList,
  setPmxInventoryReportList,
  setPmxInventoryDetailReportList,
  setProductReportList,
  setLastRefreshProductReport,
  setProductionStockReportList,
  setRawMaterialOverviewStockReportList,
  setRawMaterialStockReportList,
  setCustomerOrderReportList,
  setDeliveryReportList,
  setUsageL36M2ReportList,
  setUsageL36M2V2ReportList,
  setValueL36MReportList,
  setInvoiceDNDetailReportList,
  setUsageL36M2V2HiddenColumns,
  setValueL36MHiddenColumns,
  setInvoiceDNDetailHiddenColumns,
  setUsageL36M2V2ColumnOrder,
  setValueL36MColumnOrder,
  setInvoiceDNDetailColumnOrder,
};
